export const priceWithTaxRounded = (base: number, taxValue: number, decimals?: number): number => {
  return Number(((base * taxValue)+base).toFixed(decimals || 2))
}